import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';

@Component({
	selector: 'bt-upload-validation-results-modal',
	standalone: false,
	templateUrl: './upload-validation-results-modal.component.html',
	styleUrl: './upload-validation-results-modal.component.scss'
})
export class UploadValidationResultsModalComponent {
	dialogRef = inject(MatDialogRef<UploadValidationResultsModalComponent>);
	data = inject<any>(MAT_DIALOG_DATA);
	interval: any;
	instanceDetails: any | null = null;

	constructor(
		private commonService: CommonService,
		private snackbar: UtilitiesService
	) {
		this.interval = setInterval(() => {
			this.getInstanceDetail();
		}, 1000);

		this.getInstanceDetail();
	}

	getInstanceDetail() {
		if (this.data.instanceId) {
			this.commonService.getUploadInstanceDetails(this.data.instanceId).subscribe({
				next: (response) => {
					this.instanceDetails = response;
					if (response && response.runtimeStatus) {
						if (response.runtimeStatus == 'Completed' || response.runtimeStatus == 'Failed' || response.runtimeStatus == 'Terminated' || response.runtimeStatus == 'Canceled' || response.runtimeStatus == 'Suspended') {
							clearInterval(this.interval);
						}
					}
				},
				error: (error) => {
					clearInterval(this.interval);
					this.snackbar.showSnackbar('Error fetching upload details', SnackbarType.Error);
				}
			});
		}
	}

	close() {
		this.dialogRef.close();
	}

	confirm() {
		this.dialogRef.close();
	}
}
